import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/layout/Layout";
import HomePage from "@/pages/Home";
import AboutPage from "@/pages/About";
import KitchenPage from "@/pages/Kitchen";
import WardrobePage from "@/pages/Wardrobe";
import OfficePage from "@/pages/Office";
import ResidentialPage from "@/pages/Residential";
import GalleryPage from "@/pages/Gallery";
import BecomeDealerPage from "@/pages/BecomeDealer";
import ContactPage from "@/pages/Contact";
import DealerLoginPage from "@/pages/DealerLogin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/kitchen" element={<KitchenPage />} />
            <Route path="/wardrobe" element={<WardrobePage />} />
            <Route path="/office" element={<OfficePage />} />
            <Route path="/residential" element={<ResidentialPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/become-a-dealer" element={<BecomeDealerPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/dealer-login" element={<DealerLoginPage />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
        </Layout>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
